module.exports = __webpack_public_path__ + "static/media/your-mortgage-phone.a6407fc9.png";